<template>
    <div :class="[formGroupClass,'form-group']">
        <label class="control-label" v-if="alias">{{ alias }}:</label>
        <the-mask 
            :mask="Object.values(maskTypes[mask])"
            :ref="name" 
            type="text" 
            :class="['form-control', 'form-control-sm', { 'is-invalid' : getError }]"  
            :value="value" 
            :name="name" 
            :disabled="disabled"
            @input="onInput" 
            @blur="onBlur" />
        <div class="invalid-feedback invalid-feedback-overwrite" v-if="getError">{{ getError }}</div>
    </div>

</template>

<script>

import {TheMask} from 'vue-the-mask'

export default {

    components: { TheMask },

    props: {
        value: {},

        mask: { 
            required: true
        },

        formGroupClass : {},
            
        name : {},
        alias : {},

        disabled : {
            default: false
        },
            
        form : {
            default : null
        },
        error : {},
    },

    
    data : function () { 
        return {
            maskTypes: {
                cep : ['##.###-###'],
                cpf : ['###.###.###-##'],
                cnpj : ['##.###.###/####-##'],
                phone : ['(##) ####-####', '(##) #####-####']
            },
        }
    },
    
    computed : {
        getError(){
            if (this.form !== null) {
                return this.form.getErrors(this.name)
            }
            return false
         }
    },

    methods: {
        onInput(event) {
            this.$emit("input", event);
        },

        onBlur(event){
            this.$emit('blur')
            this.validate()
        },
        
        validate(){ 
            if (this.form != undefined){
                this.form.validate(this.name);
            }
        },

        setFocus(){
            this.$refs[this.name].focus()
        }

    }
  
};
</script>

<style>
    .invalid-feedback-overwrite {
        font-size: 12px;
    }
</style>

